module.exports = __webpack_public_path__ + "img/6.7.Chla.05956b62.png";